import * as configureSolarApi from '../store/configureSolarApi';

const pvbillReducer = (state = {
    PvbillUI: [],
    ...configureSolarApi.initialState
}, action) => {
    switch (action.type) {
        case "RECEIVE_PvBillClass_pvbillReducer":
            return { ...state, PvbillUI: action.value, isLoaded: true };
    }

    return configureSolarApi.switchCaseForDefaultActionTypesForReducers(action, state);
};
export default pvbillReducer;
